import React, { Component } from 'react';
import Button from "components/CustomButtons/Button";
import Icon from "../components/Selfcare/Common/Icon";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import Slider from "react-slick";
import { Grid } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Version from "version";
import ReactLoading from 'react-loading';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import DinSide from "assets/img/dinside.png";
import TekNo from "assets/img/tekno.png";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import ReactGA from 'react-ga';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { Alert, AlertTitle } from '@material-ui/lab';
import theme from 'theme';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);


class ChangeSubscription extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("ChangeSubscription", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            vmArg: {
                SubscriptionNo: props.SubscriptionNo,
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            Packages: null,
            ChangePriceplanDialogOpen: false,
            CancelChangeDialogOpen: false,
            OrderSent: false,
            OrderError: '',
            OrderOpen: '',
            DisableButtons: false,
            buzy: false,
            Loading: true,
            EndOfMonth: false,
            IsAdministrating: false,
            CanChangePriceplan: true,
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.SelfcareDisabled && !this.state.SelfcareDisabled) {
            auth.signOut();
        }
        if (nextState.OrderSent && !this.state.OrderSent) {
            setTimeout(
                function () {
                    MySwal.fire({
                        title: this.props.t('selfcare:notification.thankyou'),
                        html: nextState.EndOfMonth ? this.props.t('selfcare:notification.orderregisteredmontheffective') : this.props.t('selfcare:notification.orderregisteredminuteseffective'),
                        icon: 'success',
                        confirmButtonColor: theme.palette.primary.main,
                    }).then((result) => {
                        if (this.props.handleRefresh)
                            this.props.handleRefresh();
                        if (this.props.handleClose)
                            this.props.handleClose();
                    });
                }.bind(this),
                100
            );
        }
        if (nextState.OrderError && !this.state.OrderError) {
            setTimeout(
                function () {
                    MySwal.fire({
                        title: this.props.t('selfcare:notification.orderfailed'),
                        html: nextState.OrderError,
                        icon: 'error',
                        confirmButtonColor: theme.palette.primary.main,
                    }).then((result) => {
                        this.setState({ buzy: false });
                    });
                }.bind(this),
                100
            );

        }
        if (nextState.OrderOpen && !this.state.OrderOpen) {
            setTimeout(
                function () {
                    this.setState({ DisableButtons: true });
                }.bind(this),
                100
            );
        }
        if (!nextState.OrderOpen && this.state.OrderOpen) {
            setTimeout(
                function () {
                    this.setState({ DisableButtons: false });
                }.bind(this),
                100
            );
        }
        if (nextState.Message && !this.state.Message) {
            setTimeout(
                function () {
                    MySwal.fire({
                        title: nextState.Message.MessageTitle,
                        html: nextState.Message.MessageText,
                        icon: nextState.Message.MessageType,
                        confirmButtonText: nextState.Message.ConfirmButtonText,
                        confirmButtonColor: theme.palette.primary.main,
                    }).then((result) => {
                        switch (nextState.Message.Action) {
                            case 'close':
                                if (this.props.handleRefresh)
                                    this.props.handleRefresh();
                                if (this.props.handleClose)
                                    this.props.handleClose();
                                break;
                            case 'none':
                                break;
                            case 'reload':
                                window.location.reload();
                                break;
                            case 'redirect':
                                window.location.replace(nextState.Message.ActionParam);
                                break;
                            default:
                                break;
                        }
                    });
                }.bind(this),
                10
            );
        }
        if (nextState.StateName && !this.state.StateName) {
            setTimeout(
                function () {
                    this.setState({ [nextState.StateName]: nextState.StateValue });
                }.bind(this),
                5
            );
        }
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    handleConfirmChangePackageDialogClose = () => {
        this.dispatchState({
            PerformChange: { SelectedPackageNo: this.state.SelectedPackage.PackageNo, EndOfMonth: this.state.EndOfMonth }
        });
        this.setState({ ChangePriceplanDialogOpen: false, buzy: true });
    }
    handleChange = name => event => {
        this.dispatchState({ [name]: event.target.checked, ClearErrors: true });
    }
    handleRBChange = (event) => {
        this.setState({ EndOfMonth: event.target.value === 'true' ? true : false });
    }

    handleChangePriceplanDialogClose = () => {
        this.setState({ ChangePriceplanDialogOpen: false, SelectedPackage: null, error: null });
    }
    handleCancelChangeDialogClose = () => {
        this.setState({ CancelChangeDialogOpen: false, error: null });
    }
    handlePerformCancel = () => {
        this.dispatchState({ PerformCancel: true });
        this.setState({ CancelChangeDialogOpen: false });
    }
    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    handleSelectPackage = selectedPackage => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Priceplan selected'
        });
        this.setState({ SelectedPackage: selectedPackage, ChangePriceplanDialogOpen: true });

    };

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }

    render() {
        var settings = {
            arrows: true,
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        infinite: this.state.Packages && this.state.Packages.length > 3 ? true : false,
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2,
                        infinite: this.state.Packages && this.state.Packages.length > 2 ? true : false,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        infinite: this.state.Packages && this.state.Packages.length > 1 ? true : false,
                    }
                }
            ],
        };

        const classes = this.props;
        const { t } = this.props;
        return (
            <div style={{ height: '100vh' }}>
                <Dialog
                    open={this.state.ChangePriceplanDialogOpen}
                    onClose={this.handleChangePriceplanDialogClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">{this.state.IsSweden ? t('selfcare:title.change-subscription-type-swe') : t('selfcare:title.changesubscription')}</DialogTitle>
                    <DialogContent>
                        <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.wishtochangesubscription', { 0: this.state.CurrentPackage ? this.state.CurrentPackage.Name : null, 1: this.state.SelectedPackage ? this.state.SelectedPackage.Name : null }) }} />
                        {this.state.SelectedPackage && this.state.SelectedPackage.Upgrade &&
                            <div>
                                <FormLabel style={{ marginTop: '20px', marginBottom: '0px', fontSize: '14px', color: '000000DE' }} component="legend">{t('selfcare:dialog.upgrade-when')}</FormLabel>
                                <RadioGroup row aria-label={t('selfcare:dialog.upgrade-when')} name="when-to-upgrade" value={String(this.state.EndOfMonth)} onChange={this.handleRBChange}>
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio color="primary" />}
                                        label={t('selfcare:radio.option.now')}
                                        labelPlacement="end"
                                        style={{ fontSize: '14px' }}
                                    />
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio color="primary" />}
                                        label={t('selfcare:radio.option.endofmonth')}
                                        labelPlacement="end"
                                        style={{ fontSize: '14px' }}
                                    />
                                </RadioGroup>

                            </div>
                        }
                        {this.state.SelectedPackage && this.state.SelectedPackage.RolloverWillBeLost ? t('selfcare:info.datarolloverwillbelost') : null}
                        {this.state.SelectedPackage && (this.state.SelectedPackage.Downgrade || this.state.EndOfMonth) ? t('selfcare:info.changeofsubscriptionendofmonth') : t('selfcare:info.changeofsubscriptionwhenconfirmed')}
                        {this.state.SelectedPackage && this.state.SelectedPackage.ServiceChanges &&
                            <React.Fragment>
                                <br />
                                <div style={{ color: '#FF0000' }}>{this.state.SelectedPackage.ServiceChanges}</div>
                            </React.Fragment>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleConfirmChangePackageDialogClose} color="rose">
                            {t('selfcare:button.confirmuc')}
                        </Button>
                        <Button onClick={this.handleChangePriceplanDialogClose}>
                            {t('selfcare:button.canceluc')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.CancelChangeDialogOpen}
                    onClose={this.handleCancelChangeDialogClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">{this.state.IsSweden ? 'Ångra beställning' : 'Kansellere bestilling'}</DialogTitle>
                    <DialogContent>
                        {this.state.IsSweden ? 'Önskar du avbryta beställningen?' : 'Vil du kansellere bestillingen?'}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handlePerformCancel} color="rose">
                            {t('selfcare:button.confirmuc')}
                        </Button>
                        <Button onClick={this.handleCancelChangeDialogClose}>
                            {t('selfcare:button.canceluc')}
                        </Button>
                    </DialogActions>
                </Dialog>
                {this.state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', padding: '5px', textAlign: 'center' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.now-administrating-number', { 0: this.state.AdministratedMsisdn }) }} /></div>}
                <div style={{ backgroundColor: theme.palette.primary.main, color: theme.palette.common.white, padding: '20px' }}>
                    <Grid container justify="center">
                        <Grid item xs={10} >
                            <Icon name="money" size={48} color={theme.palette.common.white} />
                            <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                {this.state.IsSweden ? t('selfcare:title.change-subscription-type-swe') : t('selfcare:title.changesubscription')}
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <form>
                    {!this.state.CanChangePriceplan && <div style={{ backgroundColor: 'black', color: 'white', padding: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}>{t('selfcare:info.howtochangesubscriptiontype')}</div>}
                    <Grid container justify="center" alignItems="center">
                        <Grid item xs={10}>
                            <Slider {...settings}>
                                {this.state.Packages ? this.state.Packages.map((pack) => {
                                    return (
                                        <Card pricing raised key={pack.PackageNo} style={{ width: '150px' }}>
                                            <CardBody pricing>
                                                <div style={{ textAlign: 'left' }}>
                                                    <h5 style={{ color: '#eb4e69', margin: '0px' }}>{pack.Title}</h5>
                                                    <h3 style={{ marginTop: '10px', marginBottom: '10px' }} className={classes.cardCategory}>{pack.Name}</h3>
                                                </div>
                                                <div className={classes.icon}>
                                                    {pack.Picture === 'TEK.NO' ? <img src={TekNo} alt="TEK.No" style={{ width: '90px', position: 'absolute', right: '-23px', top: '-23px' }} /> : null}
                                                    {pack.Picture === 'DinSide' ? <img src={DinSide} alt="DinSide" style={{ width: '90px', position: 'absolute', right: '-23px', top: '-23px' }} /> : null}
                                                </div>
                                                <div style={{ height: '120px' }} className={classes.cardDescription} dangerouslySetInnerHTML={{ __html: pack.DescriptionHTML }} />
                                                <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
                                                    {pack.MonthlyPrice}
                                                </h3>
                                                {pack.Ordered ? <Button round disabled>Bestilt</Button> : !pack.CurrentPackage ? <Button round color="rose" disabled={this.state.DisableButtons || this.state.buzy || !this.state.CanChangePriceplan} onClick={() => this.handleSelectPackage(pack)}>{t('selfcare:button.changeto')}</Button> : <Button round disabled>{t('selfcare:button.current')}</Button>}
                                            </CardBody>
                                        </Card>
                                    )
                                }) : null}
                            </Slider>
                        </Grid>
                    </Grid>
                    <Grid container direction="column" justify="center" alignItems="center">
                        <Grid item>
                            {this.state.buzy && <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={'50px'} width={'50px'} />}
                        </Grid>
                        <Grid item>
                            <div style={{ paddingTop: '40px', textAlign: 'center' }}>
                                {this.state.OrderOpen && !this.state.CancelText && <div>{t('selfcare:info.orderprocessed')}</div>}
                                {this.state.CancelText &&
                                    <Alert severity="info" style={{ textAlign: 'left', marginBottom: '10px' }}>
                                        <AlertTitle>{t('selfcare:info.orderprocessed')}</AlertTitle>
                                        <span dangerouslySetInnerHTML={{ __html: this.state.CancelText }} /><br /><a href="#" onClick={(event) => { this.setState({ CancelChangeDialogOpen: true }); event.preventDefault(); }}>{this.state.IsSweden ? 'Ångra byte' : 'Angre endring'}</a>
                                    </Alert>}
                                <Button id='back' color="rose" disabled={this.state.buzy} onClick={() => this.props.handleClose() }><Icon name="back" size={32} color="#FFFFFF" />{t('selfcare:button.back')}</Button>
                            </div>
                        </Grid>
                    </Grid>
                </form>
            </div>
        );
    }
}
ChangeSubscription.propTypes = {
};

export default compose(
    withTranslation(),
)(withAITracking(reactPlugin, ChangeSubscription));